import { render, staticRenderFns } from "./MfcAdviserEnrolmentIntro.vue?vue&type=template&id=6d1af94e&scoped=true"
import script from "./MfcAdviserEnrolmentIntro.vue?vue&type=script&lang=js"
export * from "./MfcAdviserEnrolmentIntro.vue?vue&type=script&lang=js"
import style0 from "./MfcAdviserEnrolmentIntro.vue?vue&type=style&index=0&id=6d1af94e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1af94e",
  null
  
)

export default component.exports